module.exports = __webpack_public_path__ + "img/Group 961.ab090489.svg";